import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import type {DaoMedia} from "../daos/dao-media.ts";

// 상태 타입 정의
interface OnairState {
  media: DaoMedia | null;
}

const initialState: OnairState = {
  media: null
};

const onairSlice = createSlice({
  name: 'onair',
  initialState,
  reducers: {
    // 다이얼로그를 여는 액션 (type, title, message를 받음)
    mediaChange: (state, payload: PayloadAction<DaoMedia|null>): void => {
      state.media = payload.payload;
    }
  },
});

export const { mediaChange } = onairSlice.actions;
export default onairSlice.reducer;